import { Editor } from 'tinymce';

/**
 * Add a custom Paywall cut button to the toolbar
 */
export const paywall = (editor: Editor) => {
  editor.ui.registry.addButton('paywallButton', {
    text: 'Paywall Cut',
    tooltip: 'Insert paywall cut',
    icon: 'page-break',
    onAction() {
      editor.insertContent(
        '<p></p><span class="o-paywall-cut">Paywall-Schnitt &#8614</span><p></p>',
      );
    },
  });
};
